var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-manager-index',{staticClass:"mt-2",attrs:{"selectable":false}})}
var staticRenderFns = []

export { render, staticRenderFns }